import { configureStore } from "@reduxjs/toolkit";
import type { RootStoreState } from "@store/types";

import "../listeners";

import { apiMiddlewares, listenerMiddleware } from "../middlewares";
import { rootReducer } from "../rootReducer";

export const configureNewStore = (preloadedState?: Partial<RootStoreState>) =>
  configureStore({
    reducer: rootReducer,
    devTools: true,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .prepend(listenerMiddleware.middleware) // listener middleware should be placed first
        .concat(apiMiddlewares),
  });
